import * as api from '../api/dashboard';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const START = 'START';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export function createRequestTypes(base) {
  return [START, SUCCESS, ERROR].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});
}

const prefix = 'APPEALS_DASHBOARD';

export const FETCH_STATISTICS = createRequestTypes(
  `${prefix}/FETCH_STATISTICS`,
);

export const fetchStatistics = makeApiActionCreatorV3(
  api.fetchStatistics,
  FETCH_STATISTICS[START],
  FETCH_STATISTICS[SUCCESS],
  FETCH_STATISTICS[ERROR],
);

export const DASHBOARD_GET_DEFAULT_TAXING_UNIT = createRequestTypes(
  `${prefix}/DASHBOARD_GET_DEFAULT_TAXING_UNIT`,
);

export const getDashboardDefaultTaxingUnit = makeApiActionCreatorV3(
  api.getDashboardDefaultTaxingUnit,
  DASHBOARD_GET_DEFAULT_TAXING_UNIT[START],
  DASHBOARD_GET_DEFAULT_TAXING_UNIT[SUCCESS],
  DASHBOARD_GET_DEFAULT_TAXING_UNIT[ERROR],
);

export const DASHBOARD_GET_TOTAL_CASES = createRequestTypes(
  `${prefix}/DASHBOARD_GET_TOTAL_CASES`,
);

export const getTotalCases = makeApiActionCreatorV3(
  api.getTotalCases,
  DASHBOARD_GET_TOTAL_CASES[START],
  DASHBOARD_GET_TOTAL_CASES[SUCCESS],
  DASHBOARD_GET_TOTAL_CASES[ERROR],
);

export const DASHBOARD_GET_PROPTYPES = createRequestTypes(
  `${prefix}/DASHBOARD_GET_PROPTYPES`,
);

export const getPropTypes = makeApiActionCreatorV3(
  api.getPropTypes,
  DASHBOARD_GET_PROPTYPES[START],
  DASHBOARD_GET_PROPTYPES[SUCCESS],
  DASHBOARD_GET_PROPTYPES[ERROR],
);

export const DASHBOARD_GET_DETAIL = createRequestTypes(
  `${prefix}/DASHBOARD_GET_DETAIL`,
);

export const getDashboardDetail = makeApiActionCreatorV3(
  api.getDashboardDetail,
  DASHBOARD_GET_DETAIL[START],
  DASHBOARD_GET_DETAIL[SUCCESS],
  DASHBOARD_GET_DETAIL[ERROR],
);

export const DASHBOARD_GET_INFORMAL_DETAIL = createRequestTypes(
  `${prefix}/DASHBOARD_GET_INFORMAL_DETAIL`,
);

export const getDashboardInformalDetail = makeApiActionCreatorV3(
  api.getDashboardDetail,
  DASHBOARD_GET_INFORMAL_DETAIL[START],
  DASHBOARD_GET_INFORMAL_DETAIL[SUCCESS],
  DASHBOARD_GET_INFORMAL_DETAIL[ERROR],
);

export const DASHBOARD_GET_APPEAL_TYPES = createRequestTypes(
  `${prefix}/DASHBOARD_GET_APPEAL_TYPES`,
);

export const getAppealTypes = makeApiActionCreatorV3(
  api.getAppealTypes,
  DASHBOARD_GET_APPEAL_TYPES[START],
  DASHBOARD_GET_APPEAL_TYPES[SUCCESS],
  DASHBOARD_GET_APPEAL_TYPES[ERROR],
);

export const DASHBOARD_TEAM_GET_FORMAL = createRequestTypes(
  `${prefix}/DASHBOARD_TEAM_GET_FORMAL`,
);

export const getTeamFormal = makeApiActionCreatorV3(
  api.getTeamFormal,
  DASHBOARD_TEAM_GET_FORMAL[START],
  DASHBOARD_TEAM_GET_FORMAL[SUCCESS],
  DASHBOARD_TEAM_GET_FORMAL[ERROR],
);

export const DASHBOARD_TEAM_GET_INFORMAL = createRequestTypes(
  `${prefix}/DASHBOARD_TEAM_GET_INFORMAL`,
);

export const getTeamInformal = makeApiActionCreatorV3(
  api.getTeamInformal,
  DASHBOARD_TEAM_GET_INFORMAL[START],
  DASHBOARD_TEAM_GET_INFORMAL[SUCCESS],
  DASHBOARD_TEAM_GET_INFORMAL[ERROR],
);

export const DASHBOARD_TEAM_GET_PRODUCTIVITY = createRequestTypes(
  `${prefix}/DASHBOARD_TEAM_GET_PRODUCTIVITY`,
);

export const getTeamProductivity = makeApiActionCreatorV3(
  api.getTeamProductivity,
  DASHBOARD_TEAM_GET_PRODUCTIVITY[START],
  DASHBOARD_TEAM_GET_PRODUCTIVITY[SUCCESS],
  DASHBOARD_TEAM_GET_PRODUCTIVITY[ERROR],
);

export const DASHBOARD_GET_FORMAL_DATES = createRequestTypes(
  `${prefix}/DASHBOARD_GET_FORMAL_DATES`,
);

export const getFormalDates = makeApiActionCreatorV3(
  api.getFormalDates,
  DASHBOARD_GET_FORMAL_DATES[START],
  DASHBOARD_GET_FORMAL_DATES[SUCCESS],
  DASHBOARD_GET_FORMAL_DATES[ERROR],
);

export const DASHBOARD_GET_INFORMAL_DATES = createRequestTypes(
  `${prefix}/DASHBOARD_GET_INFORMAL_DATES`,
);

export const getInformalDates = makeApiActionCreatorV3(
  api.getInformalDates,
  DASHBOARD_GET_INFORMAL_DATES[START],
  DASHBOARD_GET_INFORMAL_DATES[SUCCESS],
  DASHBOARD_GET_INFORMAL_DATES[ERROR],
);

export const DASHBOARD_GET_14_DAY_DATA = createRequestTypes(
  `${prefix}/DASHBOARD_GET_14_DAY_DATA`,
);

export const get14DayData = makeApiActionCreatorV3(
  api.get14DayData,
  DASHBOARD_GET_14_DAY_DATA[START],
  DASHBOARD_GET_14_DAY_DATA[SUCCESS],
  DASHBOARD_GET_14_DAY_DATA[ERROR],
);

export const DASHBOARD_GET_NOT_SCHEDULED = createRequestTypes(
  `${prefix}/DASHBOARD_GET_NOT_SCHEDULED`,
);

export const getNotScheduled = makeApiActionCreatorV3(
  api.getNotScheduled,
  DASHBOARD_GET_NOT_SCHEDULED[START],
  DASHBOARD_GET_NOT_SCHEDULED[SUCCESS],
  DASHBOARD_GET_NOT_SCHEDULED[ERROR],
);

export const DASHBOARD_UPDATE = createRequestTypes(
  `${prefix}/DASHBOARD_UPDATE`,
);

export const updateDashboard = makeApiActionCreatorV3(
  api.updateDashboard,
  DASHBOARD_UPDATE[START],
  DASHBOARD_UPDATE[SUCCESS],
  DASHBOARD_UPDATE[ERROR],
);

export const DASHBOARD_COPY = createRequestTypes(`${prefix}/DASHBOARD_COPY`);

export const copyDashboard = makeApiActionCreatorV3(
  api.copyDashboard,
  DASHBOARD_COPY[START],
  DASHBOARD_COPY[SUCCESS],
  DASHBOARD_COPY[ERROR],
);

export const SET_DASHBOARD_DATE = `${prefix}/SET_DASHBOARD_DATE`;

export function setDashboardDate(data) {
  return async dispatch => {
    dispatch({ type: SET_DASHBOARD_DATE, data: data });
  };
}

export const SET_DASHBOARD_TAXING_UNIT = `${prefix}/SET_DASHBOARD_TAXING_UNIT`;

export function setDashboardTaxingUnit(data) {
  return async dispatch => {
    dispatch({ type: SET_DASHBOARD_TAXING_UNIT, data: data });
  };
}

export const SET_DASHBOARD_VIEW = `${prefix}/SET_DASHBOARD_VIEW`;

export function setDashboardView(data) {
  return async dispatch => {
    dispatch({ type: SET_DASHBOARD_VIEW, data: data });
  };
}

export const SET_DASHBOARD_VIEW_PRODUCTIVITY = `${prefix}/SET_DASHBOARD_VIEW_PRODUCTIVITY`;

export function setDashboardViewProductivity(data) {
  return async dispatch => {
    dispatch({ type: SET_DASHBOARD_VIEW_PRODUCTIVITY, data: data });
  };
}

export const SET_DASHBOARD_APPRAISER = `${prefix}/SET_DASHBOARD_APPRAISER`;

export function setDashboardAppraiser(data) {
  return async dispatch => {
    dispatch({ type: SET_DASHBOARD_APPRAISER, data: data });
  };
}

export const SET_DASHBOARD_PRODUCTIVITY_ROWDATA = `${prefix}/SET_DASHBOARD_PRODUCTIVITY_ROWDATA`;

export function setDashboardProductivityRowData(data) {
  return async dispatch => {
    dispatch({ type: SET_DASHBOARD_PRODUCTIVITY_ROWDATA, data: data });
  };
}

export const SET_DASHBOARD_PRODUCTIVITY_COLUMNDEFS = `${prefix}/SET_DASHBOARD_PRODUCTIVITY_COLUMNDEFS`;

export function setDashboardProductivityColumnDefs(data) {
  return async dispatch => {
    dispatch({ type: SET_DASHBOARD_PRODUCTIVITY_COLUMNDEFS, data: data });
  };
}

export const SET_DASHBOARD_PRODUCTIVITY_FILTER = `${prefix}/SET_DASHBOARD_PRODUCTIVITY_FILTER`;

export function setDashboardProductivityFilter(data) {
  return async dispatch => {
    dispatch({ type: SET_DASHBOARD_PRODUCTIVITY_FILTER, data: data });
  };
}

export const SET_DASHBOARD_PRODUCTIVITY_DATEFROM = `${prefix}/SET_DASHBOARD_PRODUCTIVITY_DATEFROM`;

export function setDashboardProductivityDateFrom(data) {
  return async dispatch => {
    dispatch({ type: SET_DASHBOARD_PRODUCTIVITY_DATEFROM, data: data });
  };
}

export const SET_DASHBOARD_PRODUCTIVITY_DATETO = `${prefix}/SET_DASHBOARD_PRODUCTIVITY_DATETO`;

export function setDashboardProductivityDateTo(data) {
  return async dispatch => {
    dispatch({ type: SET_DASHBOARD_PRODUCTIVITY_DATETO, data: data });
  };
}
